import { JSX } from 'react'

import { IconProps } from '../../icon'

const Turn: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M40 19.355C40 18.1657 39.5276 17.0253 38.6804 16.1945L37.5237 15.0378L32.9133 10.4274L31.7567 9.27071C30.0624 7.57642 27.1137 7.57642 25.4194 9.27071L9.30737 25.4153C7.56421 27.1585 7.56421 30.0094 9.30737 31.7526L16.2148 38.66C17.062 39.5072 18.1861 39.9796 19.3753 39.9796C20.5646 39.9796 21.6887 39.5072 22.5358 38.66L38.6641 22.5318C39.5113 21.6846 39.9837 20.5605 39.9837 19.3713L40 19.355ZM31.7729 13.3109L32.0662 13.0177L34.9497 15.9012L34.6565 16.1945C34.4936 16.3574 34.2329 16.3574 34.0863 16.1945L31.7892 13.8811C31.6915 13.7834 31.6752 13.653 31.6752 13.5879C31.6752 13.5227 31.6752 13.4087 31.7892 13.2946L31.7729 13.3109ZM36.9535 20.8049L20.8253 36.9332C20.027 37.7314 18.74 37.7314 17.9417 36.9332L11.0342 30.0094C10.236 29.2111 10.236 27.9241 11.0342 27.1259L27.1625 11.0139C27.9608 10.2156 29.2478 10.2156 30.0461 11.0139L30.3393 11.3071L30.0461 11.6004C29.5085 12.138 29.2152 12.8548 29.2152 13.6205C29.2152 14.3861 29.5085 15.103 30.0461 15.6406L32.3431 17.9539C32.897 18.5078 33.6301 18.7848 34.3632 18.7848C35.0963 18.7848 35.8295 18.5078 36.3834 17.9539L36.6766 17.6607L36.9698 17.9539C37.3608 18.3449 37.5726 18.8499 37.5726 19.3875C37.5726 19.9252 37.3608 20.4465 36.9698 20.8212L36.9535 20.8049Z'
      fill='black'
    />
    <path
      d='M16.8013 28.869C16.3289 28.3966 15.5469 28.3966 15.0745 28.869C14.602 29.3415 14.602 30.1234 15.0745 30.5959L17.3715 32.893C17.6159 33.1373 17.9254 33.2514 18.235 33.2514C18.5445 33.2514 18.854 33.1373 19.0984 32.893C19.5708 32.4205 19.5708 31.6385 19.0984 31.1661L16.8013 28.869Z'
      fill='black'
    />
    <path
      d='M38.4523 25.9203C37.8007 25.7737 37.1328 26.181 36.9861 26.8489C35.8458 31.8666 31.8707 35.8254 26.8693 36.9658C26.2177 37.1124 25.7941 37.764 25.9407 38.432C26.071 39.0022 26.5761 39.3769 27.13 39.3769C27.2277 39.3769 27.3092 39.3769 27.4069 39.3443C33.3206 38.0084 38.0288 33.3002 39.3647 27.3865C39.5113 26.7349 39.104 26.0669 38.4361 25.9203H38.4523Z'
      fill='black'
    />
    <path
      d='M9.32367 21.7824C9.42141 21.7986 9.50287 21.8149 9.60062 21.8149C10.1545 21.8149 10.6595 21.424 10.7899 20.87C11.9303 15.8524 15.9053 11.8936 20.9067 10.7532C21.5584 10.6066 21.9819 9.95494 21.8353 9.287C21.6887 8.63535 21.0207 8.22807 20.3691 8.3584C14.4554 9.69428 9.74724 14.4024 8.41136 20.3161C8.26474 20.9678 8.67202 21.6357 9.33996 21.7824H9.32367Z'
      fill='black'
    />
  </svg>
)

export default Turn
